export default __webpack_public_path__ + "static/dank-mono-b612402e750c3d36227951b98d5c87a2.woff2";